export default __webpack_public_path__ + "static/media/Ab3.cfbe74b3.mp3";